import { Brain } from 'iconoir-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import { Label } from 'components/ui/label';
import { Textarea } from 'components/ui/textarea';
import { SettingToggleField } from '../setting-toggle-field';
import { GreetingAiModal } from './greeting-ai-modal';
import { PresetQuestionsList } from './preset-questions-list';

type WelcomeGuideSectionProps = {
  agentName?: string;
  greeting: string;
  onGreetingChange: (value: string) => void;
  enableSmartSuggestions: boolean;
  onEnableSmartSuggestionsChange: (value: boolean) => void;
  enablePresetQuestions: boolean;
  onEnablePresetQuestionsChange: (value: boolean) => void;
  presetQuestions: string[];
  onPresetQuestionsChange: (questions: string[]) => void;
  disabled?: boolean;
};

export function WelcomeGuideSection({
  agentName,
  greeting,
  onGreetingChange,
  enableSmartSuggestions,
  onEnableSmartSuggestionsChange,
  enablePresetQuestions,
  onEnablePresetQuestionsChange,
  presetQuestions,
  onPresetQuestionsChange,
  disabled = false,
}: WelcomeGuideSectionProps) {
  const { t } = useTranslation();
  const [isGreetingAiModalOpen, setIsGreetingAiModalOpen] = useState(false);

  return (
    <>
      <fieldset
        disabled={disabled}
        className="m-0 grid min-w-0 gap-6 border-0 p-0 disabled:opacity-70"
      >
        <div>
          <div className="mb-3 flex items-center justify-between">
            <Label className="text-[16px] font-semibold leading-[1.2] text-[#3d3d3d] dark:text-true-white">
              {t('GREETING') || 'Greeting'}
            </Label>
            <Button
              type="button"
              variant="outline"
              disabled={disabled}
              className="h-[38px] shrink-0 gap-[6px] rounded-[62px] border border-grey-100 bg-grey-50 pl-[18px] pr-6 text-[16px] font-medium leading-[1.2] text-[#3d3d3d] shadow-none hover:bg-[#f0f0f0] hover:text-[#3d3d3d] dark:!border-grey-100 dark:!bg-grey-50 dark:!text-[#3d3d3d] dark:hover:!bg-[#f0f0f0] dark:hover:!text-[#3d3d3d] [&_svg]:!size-6"
              onClick={() => setIsGreetingAiModalOpen(true)}
            >
              <Brain width={24} height={24} strokeWidth={1.5} className="shrink-0 text-[#3d3d3d]" />
              {t('USE_AI') || 'Use AI'}
            </Button>
          </div>

          <Textarea
            value={greeting}
            disabled={disabled}
            onChange={(event) => onGreetingChange(event.target.value)}
            placeholder={
              disabled
                ? t('ASK_AGENT_OWNER_TO_UPDATE_GREETING') ||
                  'Ask the agent owner to update the greeting'
                : t('TYPE_YOUR_AGENT_GREETING') || "Type your agent's greeting"
            }
            rows={3}
            className="resize-none rounded-[8px] border-[#e7e7e7] bg-transparent px-5 py-4 text-[16px] font-normal leading-[1.6] text-[#3d3d3d] shadow-none placeholder:!text-[16px] placeholder:font-normal placeholder:leading-[1.6] placeholder:text-[#b0b0b0] focus-visible:ring-1 dark:border-[#3d3d3d] dark:bg-[rgba(109,109,109,0.15)] dark:text-true-white dark:placeholder:text-[#b0b0b0] dark:disabled:bg-[rgba(109,109,109,0.15)]"
          />
        </div>

        {/* <div className="w-full space-y-6">
          <SettingToggleField
            label={t('SMART_SUGGESTIONS') || 'Smart Suggestions'}
            checked={enableSmartSuggestions}
            onCheckedChange={onEnableSmartSuggestionsChange}
            disabled={disabled}
          />

          <SettingToggleField
            label={t('PRESET_QUESTIONS') || 'Preset Questions'}
            checked={enablePresetQuestions}
            onCheckedChange={onEnablePresetQuestionsChange}
            disabled={disabled}
          />
        </div> */}

        {/* {enablePresetQuestions && (
          <PresetQuestionsList
            questions={presetQuestions}
            onChange={onPresetQuestionsChange}
          />
        )} */}
      </fieldset>

      <GreetingAiModal
        open={disabled ? false : isGreetingAiModalOpen}
        onOpenChange={setIsGreetingAiModalOpen}
        onUse={onGreetingChange}
        agentName={agentName}
        greetingValue={greeting}
      />
    </>
  );
}
